module.exports = __webpack_public_path__ + "assets/img/air-pack.241456f2.png";